"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOns = void 0;
const types_1 = require("@air/types");
const request_1 = require("./request");
/**
 * @returns a list of add-ons for the workspace
 */
function list(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.addOns, {
            workspaceId,
        });
    });
}
/**
 * Batch updates add-ons for the workspace allowing for retroactive enrichment to be executed for multiple add-ons
 *
 * @deprecated
 */
function batchUpdate(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, updates, skipRetroactiveEnrichment, }) {
        yield (0, request_1.airRequest)(types_1.EndpointType.addOns, {
            workspaceId,
            method: 'PATCH',
            body: { updates, skipRetroactiveEnrichment },
        });
    });
}
exports.AddOns = {
    batchUpdate,
    list,
};
//# sourceMappingURL=addOns.js.map